<script>
  import Login from "./Login.svelte";
  import { onMount } from "svelte";
  export let visible;
  export let filename;
  export let af = { title: "", notes: "" };
  export let name;
  export let allAFs=[];
  
  let url = "";
  let db_button_holder = "";
  let loggedIn = window.customer;
  // probably needs to be removed
  let connect = window.connect;
  console.log("loggedin", loggedIn);
  
  onMount(() => {
    var options = {
      success: function(files) {
        if (af.title) {af.title +=" ";}else{af.title ="";}
        if (af.notes) {af.notes +=" ";}else{af.notes ="";}
        visible = false;
        console.log("DB files",files);        
        af.url = files[0].link;
        if(files[0].name){af.title += files[0].name;}
        if (files.length > 1) {
          for (var i = 1; i < files.length; i++) {
            
            let temp = {title: files[i].name + " " , notes: af.notes, url: files[i].link,
            speaker: "",
            tags: [],
            sku: "",
            daq: false,
            verbatim: false,
            itemid: "",
            cutaudio: false,
            cuts: { start: "", end: "" },
            timestamps: false,
            count: allAFs.length + 1
            
          };
          allAFs = allAFs.concat(temp);
        }
        console.log("allAFs", allAFs);
      }
      filename = baseName(af.url);
    }  ,
    linkType: "direct",
    multiselect: true,
    extensions: ["audio", "video"]
  };
  if (filename){
    filename = baseName(filename);
  }
  if (Dropbox) {
    var button = Dropbox.createChooseButton(options);
    //console.log(db_button_holder);
    if ( db_button_holder) {
      db_button_holder.appendChild(button) ;
    }else{
      console.log("no button holder", db_button_holder);
    }
  } else {
    console.log("No DB yet");
  }
});

function baseName(str) {
  var base = new String(str).substring(str.lastIndexOf("/") + 1);
  return base;
}
</script>

<style>
  .holder {
    border: 1px solid #ccc;
    margin-bottom: 1em;
  }
  .connect {
    padding: 0em 1em 1em 1em;
  }
  .dropbox_button_div {
    margin: 2em auto 2em auto;
  }
</style>




{#if !loggedIn}

<div class="holder {visible ? '' : 'hidden'}">
  <Login></Login>
</div>
{:else}


<div class="dropbox_button_div {visible ? '' : 'hidden'}" 
style="text-align: center;" 
bind:this={db_button_holder}>

<input type="hidden"  name="{name}.db_url"  class="db_url"/>
</div>


{/if}

